import { getObj2 } from './fetch'
export interface UsageLogInfo {
  action: string
  /* eslint-disable @typescript-eslint/naming-convention */
  business_id: string
  document_name: string
  document_type: string
  user_name: string
  /* eslint-enable @typescript-eslint/naming-convention */
  message: string
  status: string
  timestamp: string
}

export interface UsageLogList {
  logs: UsageLogInfo[]
  total: number
}

export async function getUsageLog(params) {
  return await getObj2<UsageLogList>('logs', { params })
}
